import { __assign, __extends } from "tslib";
import { PLAYBACK_EVENTS, PlaybackSingleton, } from '@wix/soundhead-playback';
import * as React from 'react';
import { defaultPlayback, defaultPlayerProps } from '../../defaultSettings';
import { isEqual, noop } from '../../utils';
import PlayerEngine from '../PlayerEngine';
var SlavePlayer = /** @class */ (function (_super) {
    __extends(SlavePlayer, _super);
    function SlavePlayer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.playback = defaultPlayback;
        _this.isFocused = false;
        _this._checkFocus = function (playerId) {
            if (playerId === _this.props.playerId) {
                _this._onFocus();
            }
            else if (_this.isFocused) {
                _this._onBlur();
            }
        };
        _this._handleFocus = function () {
            if (!_this.isFocused && _this.player) {
                _this.player.registerPlayer();
            }
            _this.props.onFocus();
        };
        _this._setPlayerRef = function (instance) {
            _this.props.playerRef(instance);
            _this.player = instance;
        };
        return _this;
    }
    SlavePlayer.prototype.componentDidMount = function () {
        this.playback = PlaybackSingleton.getInstance();
        this.playback.on(PLAYBACK_EVENTS.PLAYER_CHANGED, this._checkFocus);
        if (this.player) {
            this.player.injectPlayback(this.playback);
            if (!this.playback.hasRegisteredPlayer() || this.props.autoplay) {
                this.player.registerPlayer();
            }
        }
    };
    SlavePlayer.prototype.componentWillUnmount = function () {
        this.playback.off(PLAYBACK_EVENTS.PLAYER_CHANGED, this._checkFocus);
        if (this.isFocused) {
            this.playback.pause();
        }
        delete this.playback;
    };
    SlavePlayer.prototype.componentDidUpdate = function (prevProps) {
        var _this = this;
        [
            ['loop', 'setLoop'],
            ['volume', 'setVolume'],
            ['playbackRate', 'setPlaybackRate'],
            ['muted', 'setMute'],
            ['autoplay', 'setAutoplay'],
        ].forEach(function (_a) {
            var _b;
            var prop = _a[0], method = _a[1];
            // @ts-ignore
            if (prevProps[prop] !== _this.props[prop]) {
                // @ts-ignore
                _this.player.saveAudioProps((_b = {}, _b[prop] = _this.props[prop], _b));
                if (_this.isFocused) {
                    // @ts-ignore
                    _this.playback[method](_this.props[prop]);
                }
            }
        });
        if (this.player &&
            this.isFocused &&
            !isEqual(prevProps.playlist, this.props.playlist)) {
            this.playback.setPlaylist(this.props.playlist);
            this.player.updateTrack();
        }
    };
    SlavePlayer.prototype._onFocus = function () {
        if (this.player) {
            this.player.bindAudioEvents();
        }
        this.isFocused = true;
    };
    SlavePlayer.prototype._onBlur = function () {
        if (this.player) {
            this.player.unbindAudioEvents();
            this.player.resetPlaybackState();
        }
        this.isFocused = false;
    };
    SlavePlayer.prototype.render = function () {
        return (React.createElement(PlayerEngine, __assign({}, this.props, { ref: this._setPlayerRef, onFocus: this._handleFocus })));
    };
    SlavePlayer.displayName = 'SlavePlayer';
    SlavePlayer.defaultProps = __assign(__assign({}, defaultPlayerProps), { playerRef: noop });
    return SlavePlayer;
}(React.Component));
export default SlavePlayer;
//# sourceMappingURL=SlavePlayer.js.map